import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Produits from './pages/Produits';
import Objectifs from './pages/Objectifs';
import Activites from './pages/Activites';
import Cartographie from './pages/Cartographie';
import Performance from './pages/Performance';
import Gamification from './pages/Gamification';
import Bonus from './pages/Bonus';
import Geofencing from './pages/Geofencing';
import Planning from './pages/Planning';
import Reporting from './pages/Reporting';
import Analytics from './pages/Analytics';
import CommerciauxPage from './pages/Commerciaux';
import CommercialDetail from './pages/CommercialDetail';
// Tracking merged into Historique
import Notifications from './pages/Notifications';
import Commandes from './pages/Commandes';
import ZoneManagement from './pages/ZoneManagement';
import RolesManagement from './pages/admin/RolesManagement';
import AppSettings from './pages/admin/AppSettings';
import SecuritySettings from './pages/admin/SecuritySettings';
import Absences from './pages/Absences';
import Synchronisation from './pages/Synchronisation';
import Historique from './pages/Historique';

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <PermissionProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/admin" element={
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        }>
                            <Route index element={<Dashboard />} />
                            <Route path="users" element={<Users />} />
                            <Route path="clients" element={<Clients />} />
                            <Route path="clients/:id" element={<ClientDetail />} />
                            <Route path="produits" element={<Produits />} />
                            <Route path="objectifs" element={<Objectifs />} />
                            <Route path="activites" element={<Activites />} />
                            <Route path="commerciaux" element={<CommerciauxPage />} />
                            <Route path="commerciaux/:id" element={<CommercialDetail />} />
                            <Route path="commandes" element={<Commandes />} />
                            <Route path="cartographie" element={<Cartographie />} />
                            <Route path="performance" element={<Performance />} />
                            <Route path="gamification" element={<Gamification />} />
                            <Route path="bonus" element={<Bonus />} />
                            <Route path="geofencing" element={<Geofencing />} />
                            <Route path="zones" element={<ZoneManagement />} />
                            <Route path="planning" element={<Planning />} />
                            <Route path="reporting" element={<Reporting />} />
                            <Route path="analytics" element={<Analytics />} />
                            <Route path="tracking" element={<Navigate to="/admin/historique" replace />} />
                            <Route path="notifications" element={<Notifications />} />
                            <Route path="absences" element={<Navigate to="/admin/planning" replace />} />
                            <Route path="synchronisation" element={<Synchronisation />} />
                            <Route path="historique" element={<Historique />} />
                            <Route path="roles" element={<RolesManagement />} />
                            <Route path="settings" element={<AppSettings />} />
                            <Route path="security" element={<SecuritySettings />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </PermissionProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
